import React from 'react';
import { tokens } from '@carta/ink';
import Highcharts from 'highcharts-more-node';
import HighchartsReact from 'highcharts-react-official';
import { formatNumber } from '@carta/pen';

import ExposeDescribe from '../components/ExposeDescribe';

const DatavizExpose = () => {
  return (
    <>
      <ExposeDescribe id="Example 1" name="Example 1" key="Example 1">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              animation: false,
              height: 320,
              width: 452,
              style: {
                fontFamily: tokens.font.global.family.base,
              },
            },
            colors: [tokens.color.global.visualization['category-1'].default],
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointPadding: 0.1,
                groupPadding: 0,
                borderWidth: 0,
                maxPointWidth: 45,
              },
              line: {
                lineWidth: 4,
                marker: false,
              },
              series: {
                animation: false,
                states: {
                  hover: {
                    enabled: false,
                  },
                },
              },
            },
            series: [
              {
                name: 'Cash balance',
                type: 'column',
                data: [101, 105, 104, 120, 119, 118, 123, 130, 133, 140, 138, 130],
              },
            ],
            subtitle: {
              align: 'left',
              style: {
                fontSize: tokens.font.global.size['small-1'],
                color: tokens.color.global.font.custom.gray.default,
              },
            },
            title: {
              align: 'left',
              margin: 40,
              style: {
                fontSize: tokens.font.global.size['body-1'],
                fontWeight: tokens.font.global.weight['body-1'],
              },
              text: 'Employee base grew by 30% in 2022',
            },
            tooltip: {
              enabled: false,
            },
            xAxis: {
              categories: [
                'Jan.',
                'Feb.',
                'March',
                'April',
                'May',
                'June',
                'July',
                'Aug.',
                'Sept.',
                'Oct.',
                'Nov.',
                'Dec.',
              ],
              labels: {
                autoRotation: undefined,
                style: {
                  color: tokens.color.global.font.hierarchy.body.default,
                },
              },
              lineColor: tokens.color.global.border.separation.weak.default,
              zIndex: 4,
            },
            yAxis: {
              gridLineColor: tokens.color.global.border.separation.weak.default,
              labels: {
                align: 'right',
                autoRotation: undefined,
                style: {
                  color: tokens.color.global.font.hierarchy.body.default,
                },
                x: -8,
                y: 0,
              },
              plotLines: [
                {
                  value: 0,
                  color: '#000',
                  width: 1,
                  zIndex: 4,
                },
              ],
              tickAmount: 5,
              title: {
                align: 'high',
                margin: 0,
                reserveSpace: false,
                rotation: 0,
                style: {
                  color: tokens.color.global.font.custom.gray.default,
                  background: 'white',
                  padding: '0 4px 4px 6px',
                },
                text: 'Headcount',
                textAlign: 'left',
                useHTML: true,
                x: 35,
              },
            },
          }}
        />
      </ExposeDescribe>

      <ExposeDescribe id="Example 2" name="Example 2" key="Example 2">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              animation: false,
              height: 320,
              width: 452,
              style: {
                fontFamily: tokens.font.global.family.base,
              },
            },
            colors: [
              tokens.color.global.visualization['category-2'].default, // category-2
            ],
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointPadding: 0.1,
                groupPadding: 0,
                borderWidth: 0,
                maxPointWidth: 45,
              },
              line: {
                lineWidth: 4,
                marker: false,
              },
              series: {
                animation: false,
                states: {
                  hover: {
                    enabled: false,
                  },
                },
              },
            },
            series: [
              {
                name: 'Cash balance',
                type: 'column',
                data: [12541723, 12261236, 11856359, 11224971, 10164766],
              },
            ],
            subtitle: {
              align: 'left',
              style: {
                fontSize: tokens.font.global.size['small-1'],
                color: tokens.color.global.font.custom.gray.default,
              },
              text: 'Cash balance has been predictable for the past 5 months',
            },
            title: {
              align: 'left',
              margin: 40,
              style: {
                fontSize: tokens.font.global.size['body-1'],
                fontWeight: tokens.font.global.weight['body-1'],
              },
              text: 'Cash balance, monthly',
            },
            tooltip: {
              enabled: false,
            },
            xAxis: {
              categories: ['Jan.', 'Feb.', 'March', 'April', 'May'],
              labels: {
                autoRotation: undefined,
                style: {
                  color: tokens.color.global.font.hierarchy.body.default,
                },
              },
              lineColor: tokens.color.global.border.separation.weak.default,
            },
            yAxis: {
              gridLineColor: tokens.color.global.border.separation.weak.default,
              labels: {
                align: 'right',
                autoRotation: undefined,
                style: {
                  color: tokens.color.global.font.hierarchy.body.default,
                },
                x: -8,
                y: 0,
                /* eslint-disable object-shorthand */
                formatter: function yAxisFormatter() {
                  /* eslint-disable react/no-this-in-sfc */
                  return formatNumber(this.value, '$0a').toUpperCase();
                },
              },
              min: 0,
              plotLines: [
                {
                  value: 0,
                  color: '#000',
                  width: 1,
                  zIndex: 4,
                },
              ],
              tickAmount: 5,
              title: {
                align: 'high',
                margin: 0,
                reserveSpace: false,
                rotation: 0,
                style: {
                  color: tokens.color.global.font.custom.gray.default,
                  background: 'white',
                  padding: '0 4px 4px 6px',
                },
                text: 'Cash balance',
                textAlign: 'left',
                useHTML: true,
                x: 35,
              },
            },
          }}
        />
      </ExposeDescribe>

      <ExposeDescribe id="Example 3" name="Example 3" key="Example 3">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              animation: false,
              height: 320,
              width: 452,
              style: {
                fontFamily: tokens.font.global.family.base,
              },
            },
            colors: [tokens.color.global.visualization.negative.default],
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointPadding: 0.1,
                groupPadding: 0,
                borderWidth: 0,
                maxPointWidth: 45,
              },
              line: {
                lineWidth: 4,
                marker: false,
              },
              series: {
                animation: false,
                states: {
                  hover: {
                    enabled: false,
                  },
                },
              },
            },
            series: [
              {
                name: 'Cash balance',
                type: 'column',
                data: [null, -280487, -404877, -631388, -1060205],
              },
            ],
            subtitle: {
              align: 'left',
              style: {
                fontSize: tokens.font.global.size['small-1'],
                color: tokens.color.global.font.custom.gray.default,
              },
              text: 'Since January, burn rate has increased 3.8x',
            },
            title: {
              align: 'left',
              margin: 40,
              style: {
                fontSize: tokens.font.global.size['body-1'],
                fontWeight: tokens.font.global.weight['body-1'],
              },
              text: 'Cash burn, monthly',
            },
            tooltip: {
              enabled: false,
            },
            xAxis: {
              categories: ['Jan.', 'Feb.', 'March', 'April', 'May'],
              labels: {
                autoRotation: undefined,
                style: {
                  color: tokens.color.global.font.hierarchy.body.default,
                },
                y: -10,
              },
              lineColor: tokens.color.global.border.separation.weak.default,
              top: '-100%',
            },
            yAxis: {
              gridLineColor: tokens.color.global.border.separation.weak.default,
              labels: {
                align: 'right',
                autoRotation: undefined,
                style: {
                  color: tokens.color.global.font.hierarchy.body.default,
                },
                x: -8,
                y: 0,
                /* eslint-disable object-shorthand */
                formatter: function yAxisFormatter() {
                  /* eslint-disable react/no-this-in-sfc */
                  return formatNumber(this.value, '$0a').toUpperCase();
                },
              },
              plotLines: [
                {
                  value: 0,
                  color: '#000',
                  width: 1,
                  zIndex: 4,
                },
              ],
              tickAmount: 5,
              title: {
                align: 'low',
                margin: 0,
                reserveSpace: false,
                rotation: 0,
                style: {
                  color: tokens.color.global.font.custom.gray.default,
                  background: 'white',
                  padding: '0 4px 4px 6px',
                },
                text: 'Burn',
                textAlign: 'left',
                useHTML: true,
                x: 50,
              },
            },
          }}
        />
      </ExposeDescribe>

      <ExposeDescribe id="Example 4" name="Example 4" key="Example 4">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              animation: false,
              height: 320,
              width: 452,
              style: {
                fontFamily: tokens.font.global.family.base,
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointPadding: 0.1,
                groupPadding: 0,
                borderWidth: 0,
                maxPointWidth: 45,
              },
              line: {
                lineWidth: 4,
                marker: false,
                dataLabels: {
                  align: 'left',
                  crop: false,
                  enabled: true,
                  formatter: function labelFormatter() {
                    const series = this.series;
                    if (this.point === series.points[series.points.length - 1]) {
                      return series.name;
                    }
                  },
                  overflow: 'allow',
                  states: {
                    hover: {
                      enabled: false,
                    },
                  },
                  style: {
                    color: tokens.color.global.font.custom.gray.default,
                    textOutline: false,
                  },
                },
              },
              series: {
                animation: false,
                states: {
                  hover: {
                    enabled: false,
                  },
                },
              },
            },
            series: [
              {
                color: tokens.color.global.visualization.neutral['intensity-0'],
                name: 'Startup Y',
                label: 'something',
                type: 'line',
                data: [120, 123, 115, 100],
              },
              {
                color: tokens.color.global.visualization.neutral['intensity-0'],
                name: 'Startup Z',
                type: 'line',
                data: [98, 102, 93, 80],
              },
              {
                name: 'Startup X',
                color: tokens.color.global.visualization.negative.default,
                type: 'line',
                data: [101, 120, 123, 140],
              },
            ],
            subtitle: {
              align: 'left',
              style: {
                fontSize: 13,
                color: '#797675',
              },
              text: 'Q4 headcount reached 140 (+40% from January)',
            },
            title: {
              align: 'left',
              margin: 40,
              style: {
                fontSize: 14,
                fontWeight: 'bold',
              },
              text: 'Headcount and hiring pace are alarming',
            },
            tooltip: {
              enabled: false,
            },
            xAxis: {
              categories: ['Jan.', 'Feb.', 'March', 'April', 'May'],
              labels: {
                autoRotation: undefined,
                style: {
                  color: '#3d3b3b',
                },
              },
              lineColor: '#ecebeb',
            },
            yAxis: {
              gridLineColor: '#ecebeb',
              labels: {
                align: 'right',
                autoRotation: undefined,
                style: {
                  color: '#3d3b3b',
                },
                x: -8,
                y: 0,
              },
              plotLines: [
                {
                  value: 0,
                  color: '#000',
                  width: 1,
                  zIndex: 4,
                },
              ],
              tickAmount: 5,
              title: {
                align: 'high',
                margin: 0,
                reserveSpace: false,
                rotation: 0,
                style: {
                  color: '#797675',
                  background: 'white',
                  padding: '0 4px 4px 6px',
                },
                text: 'Headcount',
                textAlign: 'left',
                useHTML: true,
                x: 35,
              },
            },
          }}
        />
      </ExposeDescribe>
    </>
  );
};

export default DatavizExpose;
